/**
 * Shared styles for information cards across the app.
 * Matches the design: soft rounded corners, light blue border/bg, dark grey-blue text, check icon.
 */

/** Container: significantly rounded, thin light blue border, very light blue background, no shadow */
export const INFO_CARD_WRAPPER =
  'rounded-2xl border border-[#A5D8FF] bg-[#E8F4FC] p-4';

export const INFO_CARD_WRAPPER_P5 =
  'rounded-2xl border border-[#A5D8FF] bg-[#E8F4FC] p-5';

/** Title / heading inside info card */
export const INFO_CARD_TITLE =
  "font-['Roboto:SemiBold',sans-serif] font-semibold text-[14px] text-[#333C4D]";

/** Body text inside info card */
export const INFO_CARD_TEXT =
  "font-['Roboto:Regular',sans-serif] text-[13px] text-[#333C4D] leading-relaxed";

/** Label / secondary line (e.g. "Duplicating from:") */
export const INFO_CARD_LABEL =
  "font-['Roboto:Medium',sans-serif] text-[13px] text-[#333C4D] mb-1";

/** Value text (e.g. facility/location name) */
export const INFO_CARD_VALUE =
  "font-['Roboto:SemiBold',sans-serif] font-semibold text-[15px] text-[#333C4D]";

/** Check icon (image 1): circle transparent inside, thick outline, medium blue; check same blue, thick */
export const INFO_CARD_CHECK_BLUE = '#6AB5DD';
export const INFO_CARD_ICON_WRAPPER =
  'w-5 h-5 rounded-full bg-transparent border-2 border-[#6AB5DD] flex items-center justify-center flex-shrink-0 mt-0.5';
export const INFO_CARD_ICON_CLASS = 'w-2.5 h-2.5 text-[#6AB5DD] stroke-[4]';

/** Smaller variant for list items */
export const INFO_CARD_ICON_WRAPPER_SM =
  'w-4 h-4 rounded-full bg-transparent border-2 border-[#6AB5DD] flex items-center justify-center flex-shrink-0';
export const INFO_CARD_ICON_CLASS_SM = 'w-2 h-2 text-[#6AB5DD] stroke-[3]';

/** Tag/chip inside info card (e.g. area names) - light, consistent with card */
export const INFO_CARD_TAG =
  'inline-flex items-center px-2.5 py-1 bg-white/80 border border-[#A5D8FF] text-[#333C4D] rounded-xl text-[12px] font-["Roboto:Medium",sans-serif]';
